export default "<p-menubar [model]=\"items\"></p-menubar>\r\n"